import { useTranslation } from 'react-i18next';
import type { AiCategory } from '@b4b/shared';

/** Localized label for an AI topic (section title, filter chip). */
export function useTopicLabel(): (topic: AiCategory) => string {
  const { t } = useTranslation();
  return (topic) => t(`topics.${topic}`);
}
